import React from "react";

// eslint-disable-next-line
export default (props) => (
  /* eslint-disable */
  <button onClick={() => stop() & playKey(props.idNote, props.octave)}>
    {" "}
    {props.Note}
  </button>
);
